<div
  class="top-gap centered-container"
  fxLayout="column"
  fxLayoutAlign="start center"
  fxLayoutGap="12px"
>
  <app-image-carousel fxFill></app-image-carousel>
  <div
    *ngIf="serviceResults$ | async as serviceResults; else loading"
    fxLayout="column"
    fxLayoutAlign="start center"
    fxLayoutGap="12px"
  >
    <app-service-result
      fxFill
      *ngFor="let serviceResult of serviceResults"
      [result]="serviceResult"
    ></app-service-result>
  </div>
</div>

<ng-template #loading>
  <app-loading-spinner
    class="results-spinner"
    [show]="true"
  ></app-loading-spinner
></ng-template>
